import { CountryV2 } from "@hagerty/customer-insurance-gateway-client";
import { Source } from "../../types";

export function sourceToCountry(source: Source): CountryV2 {
  return source.toUpperCase() as CountryV2;
}

export function countryToSource(source: CountryV2): Source {
  return source.toLowerCase() as Source;
}
